import { z } from "zod";
import { subscriberType } from "./enums";

export const subscribeSchema = z.object({
  emailAddress: z.string().min(1, "E-post krävs").email("Ogiltig e-postadress"),
  subscriberType,
});

export type SubscribeInput = z.infer<typeof subscribeSchema>;

// The landing/waitlist dialog collects only an email (type is fixed to personal).
export const waitlistFormSchema = z.object({
  email: z.string().min(1, "E-post krävs").email("Ogiltig e-postadress"),
});

export type WaitlistFormInput = z.infer<typeof waitlistFormSchema>;
